
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPatientProfileDetails } from './actions/PatientActions';
import { NavLink } from 'react-router-dom';
import { ProfileModal } from './components/common/displayProfile';
import { base64Encode, showFormatedDate } from './../../actions/utilAction';
import user1 from '../../img/doctor.png';

class PatientInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patientId: props.patientId ? props.patientId : null,
      placement: 'bottom',
      patientObj: {},
      allergyData: [],
      phoneArray: [],
      addressArray: [],
      diagnosisArray: [],
      nextAppointmentArray: [],
      allergiesArray: [],
      tagsArray: [],
      openImage: false,
    };
  }

  setProfileData(patientData) {
    let patientDetails = patientData.patientInfo && patientData.patientInfo.length ? patientData.patientInfo[0] : {};
    this.setState({
      patientObj: patientDetails,
    });

    this.setState({
      addressArray: patientData.patientAddressesModel,
      phoneArray: patientData.phoneNumberModel,
      diagnosisArray: patientData.patientDiagnosisDetails,
      allergiesArray: patientData.patientAllergyModel,
      nextAppointmentArray: patientData.upcomingAppointmentDetails,
      tagsArray: patientData.patientTagsModel,
    });
  }

  componentWillMount() {
    // if (this.props.patientProfileData) {
    // let patientData = this.props.patientProfileData.data;
    // this.setProfileData(patientData);
    // } else
    if (this.state.patientId) {
      this.props.getPatientProfileDetails(this.state.patientId);
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)
    if (nextProps.patientProfileData && nextProps.patientProfileData !== this.props.patientProfileData) {
      this.setProfileData(nextProps.patientProfileData.data);
    }
  }

  handleOpen = () => {
    this.setState({ openImage: true });
  };

  handleClose = () => {
    this.setState({ openImage: false });
  };

  handlePlacementChange = (event, placement) => {
    this.setState({ placement });
  };

  renderTags() {
    if (!this.state.tagsArray.length) {
      return 'No tag found.';
    } else {
      return (<ul className="tags">
        {this.state.tagsArray.map((patientTag, index) => {
          let tagName = patientTag.tag
            , tagColor = patientTag.colorCode
            , tagFontColor = patientTag.fontColorCode;
          return (
            <li key={index}>
              <span className="tagafter" style={{ backgroundColor: tagColor }}>
              </span>
              <span className="tag" style={{ backgroundColor: tagColor, color: tagFontColor }}>
                {tagName}
              </span>
            </li>);
        })}
      </ul>);
    }
  }

  renderAllergies() {
    if (!this.state.allergiesArray.length) {
      return <p>No allergies found.</p>;
    } else {
      return (<p>
        <b>Allergies</b>
        {this.state.allergiesArray.map((data, index) => {
          return <span key={index}>{`${data.allergyType} (${data.allergen})`}</span>;
        })}
      </p>);
    }
  };
  resolveJavascript = () => {
    return '#';
  };

  render() {

    let { photoPath, photoThumbnailPath, name, gender, dob, ssn, mrn, email, isActive, isBlock } = this.state.patientObj;
    let phoneNumber = '',
      fullAddress = ''
      , addressTypeName = ''
      , phoneType = ''
      , ssnLast4Digits = ssn ? ssn.substr(ssn.length - 4) : ''
      // , mrnLast4Digits = mrn ? mrn.substr(mrn.length - 4) : ''
      , mrnNumber = mrn ? mrn : ''
      , fullName = name
      , primaryProviderName = ''
      , nextAppointmentDate = '';
    let phoneDetail = this.state.phoneArray && this.state.phoneArray.length ? this.state.phoneArray[0] : null;
    let nextAppointmentData = this.state.nextAppointmentArray && this.state.nextAppointmentArray.length ? this.state.nextAppointmentArray[0] : null;
    if (phoneDetail) {
      phoneNumber = phoneDetail.phoneNumber;
      phoneType = phoneDetail.phoneNumberType;
    }
    if (this.state.addressArray && this.state.addressArray.length) {
      let AddressDetail = this.state.addressArray && this.state.addressArray.length ? this.state.addressArray.find((obj, index) => obj.addressType.toUpperCase() === 'PRIMARY HOME') : null;
      if (AddressDetail) {
        let { address1, city, stateName, countryName, zip, addressType } = AddressDetail;
        fullAddress = `${address1}, ${city}, ${stateName}, ${countryName}, ${zip}`;
        addressTypeName = addressType;
      }
    }
    if (nextAppointmentData) {
      nextAppointmentDate = nextAppointmentData.upcomingAppointment;
    }
    let encodePatientId = base64Encode(`${this.state.patientId}`);

    return (
      <div className="client_profile">
        {this.state.openImage ?
          <ProfileModal openImage={(this.state.openImage && photoPath) ? true : false} closeDialog={this.handleClose} profileFullPicture={photoPath || user1} />
          : ''}
        <div className="quick rr">
          <ul>
            <li className="red">
              <a href={this.resolveJavascript()} title="Tags"><i className="fa fa-tag" ></i></a>
              <div className="quicksubmenu tagbox plr-10">
                {this.renderTags()}

              </div>
            </li>
            <li className="blue">
              <a href={this.resolveJavascript()} title="Contact"><i className="fa fa-phone"></i></a>
              <ul className="quicksubmenu">
                <li><i className="fa fa-phone" aria-hidden="true"></i>
                  {phoneNumber ? `${phoneNumber} (${phoneType})` : '-'}
                </li>
                <li className="msg"><i className="fa fa-envelope" aria-hidden="true"></i>
                  {email || '-'}
                </li>
                <li><i className="fa fa-map-marker" aria-hidden="true"></i>
                  {fullAddress ? `${fullAddress} (${addressTypeName})` : '-'}
                </li>
              </ul>
            </li>
            <li className="green">
              <a href={this.resolveJavascript()} title="Bio-Psych Social Intake"><i className="fa fa-user-md"></i></a>
              <div className="quicksubmenu">
                <p>
                  <b>Primary Provider</b>
                  <span>{primaryProviderName || '-'}</span>
                </p>
                {this.state.allergiesArray && this.state.allergiesArray.length > 0 ?
                  this.renderAllergies()
                : null}
              </div>
            </li>
            <li className="orange"><NavLink to={`/client/scheduling/${encodePatientId}`} title="scheduling" exact ><i className="fa fa-calendar" aria-hidden="true"></i></NavLink></li>
          </ul>
        </div>
        <div className="clientbox">

          {isActive && isBlock ?
            <div className='user_pic activec lock'>
              {photoThumbnailPath ? <img src={photoThumbnailPath} alt="" onClick={this.handleOpen} /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
              <i className="fa fa-lock" aria-hidden="true"></i>
            </div>
            : null}

          {isActive && isBlock === false ?
            <div className='user_pic activec'>
              {photoThumbnailPath ? <img src={photoThumbnailPath} alt="" onClick={this.handleOpen} /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
              <i className="fa fa-circle" aria-hidden="true"></i>
            </div>
            : null}

          {isActive === false && isBlock ?
            <div className='user_pic inactive lock'>
              {photoThumbnailPath ? <img src={photoThumbnailPath} alt="" onClick={this.handleOpen} /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
              <i className="fa fa-lock" aria-hidden="true"></i>
            </div>
            : null}

          {isActive === false && isBlock === false ?
            <div className='user_pic inactive'>
              {photoThumbnailPath ? <img src={photoThumbnailPath} alt="" onClick={this.handleOpen} /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
              <i className="fa fa-circle" aria-hidden="true"></i>
            </div>
            : null}

          <div className="userlinks">
            <p>
              <NavLink to={`/client/profile/${encodePatientId}`} exact >{fullName || '-'}</NavLink>
            </p>
          </div>
          <div className="client_detail">
            <p><b>Gender :</b> <span>{gender}</span></p>
            <p><b>D.O.B :</b> <span>{dob ? showFormatedDate(dob) : '-'}</span></p>
            {ssnLast4Digits ?
              <p><b>SSN :</b> <span>{ssnLast4Digits ? '***-**-' + ssnLast4Digits : '-'}<i aria-hidden="true"></i></span></p>
              : null}
            {/* {mrnLast4Digits ?
              <p><b>Client ID :</b> <span>{mrnLast4Digits ? '*****' + mrnLast4Digits : '-'}<i aria-hidden="true"></i></span></p>
              : null} */}
              {mrnNumber ?
              <p><b>Client ID :</b> <span>{mrnNumber ? mrnNumber : '-'}<i aria-hidden="true"></i></span></p>
              : null}              
            {nextAppointmentDate ?
              <p><b>Next Appointment :</b> <span>{nextAppointmentDate ? showFormatedDate(nextAppointmentDate) : '-'}</span></p>
              : null}
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    patientProfileData: state.patient.patientProfileDetails,
  };
}

export default connect(mapStateToProps, { getPatientProfileDetails })(PatientInfo);



// WEBPACK FOOTER //
// ./src/modules/patients/patient_info.js